const PRODUCT_MEDIA_SWIPER_DEBUG =
  (() => {
    try {
      return (
        window.location.search.includes("debug-swiper=1") ||
        window.localStorage.getItem("debug-product-media-swiper") === "1"
      );
    } catch {
      return window.location.search.includes("debug-swiper=1");
    }
  })();

function normalizeMobileSwiperSectionId(sectionRef) {
  if (!sectionRef) return "";

  return String(sectionRef)
    .trim()
    .replace(/^#/, "")
    .replace(/^swiper-mobile-media-/, "")
    .replace(/^swiper-mobile-thumbs-/, "");
}

function getMobileSwiperNodes(sectionId) {
  const mainId = `swiper-mobile-media-${sectionId}`;
  const thumbsId = `swiper-mobile-thumbs-${sectionId}`;

  return {
    sectionId,
    mainId,
    thumbsId,
    mainEl: document.getElementById(mainId),
    thumbsEl: document.getElementById(thumbsId),
    mainMatches: document.querySelectorAll(`[id="${mainId}"]`).length,
    thumbsMatches: document.querySelectorAll(`[id="${thumbsId}"]`).length,
  };
}

window.__productMediaSwiperRegistry =
  window.__productMediaSwiperRegistry || new Map();

window.__productMediaSwiperDebug =
  window.__productMediaSwiperDebug || {
    enabled: PRODUCT_MEDIA_SWIPER_DEBUG,
    log(stage, payload = {}) {
      if (!this.enabled) return;
      console.groupCollapsed(`[product-media-swiper] ${stage}`);
      console.table(payload);
      console.trace();
      console.groupEnd();
    },
    snapshot(sectionRef, label = "snapshot") {
      if (!this.enabled) return null;

      const sectionId = normalizeMobileSwiperSectionId(sectionRef);
      const { mainEl, thumbsEl, mainId, thumbsId, mainMatches, thumbsMatches } =
        getMobileSwiperNodes(sectionId);
      const mainSwiper = mainEl?.swiper || null;
      const thumbSwiper = thumbsEl?.swiper || null;

      const payload = {
        label,
        sectionId,
        mainId,
        thumbsId,
        mainMatches,
        thumbsMatches,
        mainExists: Boolean(mainEl),
        thumbsExists: Boolean(thumbsEl),
        mainWidth: mainEl?.getBoundingClientRect?.().width || 0,
        mainHeight: mainEl?.getBoundingClientRect?.().height || 0,
        thumbWidth: thumbsEl?.getBoundingClientRect?.().width || 0,
        thumbHeight: thumbsEl?.getBoundingClientRect?.().height || 0,
        mainHasSwiper: Boolean(mainSwiper),
        thumbHasSwiper: Boolean(thumbSwiper),
        mainDestroyed: mainSwiper?.destroyed ?? null,
        thumbDestroyed: thumbSwiper?.destroyed ?? null,
        mainAllowTouchMove: mainSwiper?.allowTouchMove ?? null,
        mainActiveIndex: mainSwiper?.activeIndex ?? null,
        mainSlides: mainSwiper?.slides?.length ?? mainEl?.querySelectorAll(".swiper-slide")?.length ?? 0,
        thumbActiveIndex: thumbSwiper?.activeIndex ?? null,
        thumbSlides: thumbSwiper?.slides?.length ?? thumbsEl?.querySelectorAll(".swiper-slide")?.length ?? 0,
        bodyOverflowHidden: document.body.classList.contains("overflow-hidden"),
        htmlScrollLocked:
          document.documentElement.getAttribute("data-scroll-lock") === "true",
      };

      this.log(label, payload);
      return payload;
    },
  };

function buildMobileSwiperDebugHandlers(sectionId, type) {
  return {
    init(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:init`, {
        sectionId,
        slides: swiper.slides.length,
        width: swiper.width,
        height: swiper.height,
        activeIndex: swiper.activeIndex,
        allowTouchMove: swiper.allowTouchMove,
      });
    },
    observerUpdate(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:observer-update`, {
        sectionId,
        width: swiper.width,
        height: swiper.height,
        activeIndex: swiper.activeIndex,
      });
    },
    touchStart(swiper, event) {
      window.__productMediaSwiperDebug?.log(`${type}:touch-start`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        allowTouchMove: swiper.allowTouchMove,
        width: swiper.width,
        isTouched: swiper.isTouched,
        isMoved: swiper.isMoved,
        startX: swiper.touches?.startX ?? null,
        startY: swiper.touches?.startY ?? null,
        targetTag: event?.target?.tagName || null,
        targetClass: event?.target?.className || null,
      });
    },
    touchMove(swiper, event) {
      window.__productMediaSwiperDebug?.log(`${type}:touch-move`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        currentX: swiper.touches?.currentX ?? null,
        currentY: swiper.touches?.currentY ?? null,
        diff: swiper.touches?.diff ?? null,
        isTouched: swiper.isTouched,
        isMoved: swiper.isMoved,
        swipeDirection: swiper.swipeDirection || null,
        targetTag: event?.target?.tagName || null,
        targetClass: event?.target?.className || null,
      });
    },
    sliderFirstMove(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:first-move`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        isBeginning: swiper.isBeginning,
        isEnd: swiper.isEnd,
        diff: swiper.touches?.diff ?? null,
        currentX: swiper.touches?.currentX ?? null,
        currentY: swiper.touches?.currentY ?? null,
        swipeDirection: swiper.swipeDirection || null,
      });
    },
    touchEnd(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:touch-end`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        translate: swiper.translate,
        diff: swiper.touches?.diff ?? null,
        currentX: swiper.touches?.currentX ?? null,
        currentY: swiper.touches?.currentY ?? null,
        isTouched: swiper.isTouched,
        isMoved: swiper.isMoved,
        swipeDirection: swiper.swipeDirection || null,
      });
    },
    slideChange(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:slide-change`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        realIndex: swiper.realIndex,
      });
    },
    beforeDestroy(swiper) {
      window.__productMediaSwiperDebug?.log(`${type}:before-destroy`, {
        sectionId,
        activeIndex: swiper.activeIndex,
        destroyed: swiper.destroyed,
      });
    },
  };
}

function initMobileSwiper(sectionRef, options = {}) {
  const sectionId = normalizeMobileSwiperSectionId(sectionRef);

  if (!sectionId) return;

  if (window.innerWidth >= 825 || typeof Swiper === "undefined") {
    window.__productMediaSwiperDebug?.log("skip-init", {
      sectionId,
      reason: window.innerWidth >= 825 ? "desktop" : "swiper-missing",
      source: options.source || "unknown",
    });
    return;
  }

  const initSwiper = (attempt = 0) => {
    const {
      mainEl,
      thumbsEl,
      mainId,
      thumbsId,
      mainMatches,
      thumbsMatches,
    } = getMobileSwiperNodes(sectionId);

    if (!mainEl || !thumbsEl) {
      window.__productMediaSwiperDebug?.log("missing-nodes", {
        sectionId,
        source: options.source || "unknown",
        attempt,
        mainId,
        thumbsId,
        mainMatches,
        thumbsMatches,
      });
      return;
    }

    const mainRect = mainEl.getBoundingClientRect();
    const thumbSlidesCount = thumbsEl.querySelectorAll(".swiper-slide").length;

    if (
      (mainRect.width === 0 || mainRect.height === 0 || thumbSlidesCount === 0) &&
      attempt < 8
    ) {
      window.__productMediaSwiperDebug?.log("defer-init", {
        sectionId,
        source: options.source || "unknown",
        attempt,
        mainWidth: mainRect.width,
        mainHeight: mainRect.height,
        thumbSlidesCount,
      });

      window.setTimeout(() => initSwiper(attempt + 1), 80);
      return;
    }

    const previousMainIndex = mainEl.swiper?.activeIndex || 0;
    const previousThumbIndex = thumbsEl.swiper?.activeIndex || 0;
    const maxIndex = Math.max(thumbSlidesCount - 1, 0);
    const targetIndex = Math.min(previousMainIndex, maxIndex);
    const targetThumbIndex = Math.min(previousThumbIndex, maxIndex);
    const swiperShell = mainEl.closest("slider-component") || mainEl.parentElement;

    window.__productMediaSwiperDebug?.snapshot(
      sectionId,
      `before-init:${options.source || "unknown"}`,
    );

    if (mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }

    if (thumbsEl.swiper) {
      thumbsEl.swiper.destroy(true, true);
    }

    const thumbSwiper = new Swiper(thumbsEl, {
      initialSlide: targetThumbIndex,
      slidesPerView: "auto",
      spaceBetween: 8,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      on: buildMobileSwiperDebugHandlers(sectionId, "thumbs"),
    });

    const mainSwiper = new Swiper(mainEl, {
      initialSlide: targetIndex,
      speed: 0,
      slidesPerView: 1,
      allowTouchMove: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      watchOverflow: true,
      navigation: {
        nextEl: swiperShell?.querySelector(".swiper-button-next"),
        prevEl: swiperShell?.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperShell?.querySelector(".swiper-pagination"),
        clickable: true,
      },
      thumbs: {
        swiper: thumbSwiper,
      },
      on: buildMobileSwiperDebugHandlers(sectionId, "main"),
    });

    window.__productMediaSwiperRegistry.set(sectionId, {
      source: options.source || "unknown",
      main: mainSwiper,
      thumbs: thumbSwiper,
      lastInitAt: Date.now(),
    });

    mainSwiper.slideTo(targetIndex, 0);
    thumbSwiper.slideTo(targetThumbIndex, 0);

    requestAnimationFrame(() => {
      mainSwiper.update();
      thumbSwiper.update();
    });

    window.setTimeout(() => {
      if (!mainSwiper.destroyed) mainSwiper.update();
      if (!thumbSwiper.destroyed) thumbSwiper.update();
      window.__productMediaSwiperDebug?.snapshot(
        sectionId,
        `after-init:${options.source || "unknown"}`,
      );
    }, 120);
  };

  initSwiper();
}

function refreshMobileSwiper(sectionRef, options = {}) {
  const sectionId = normalizeMobileSwiperSectionId(sectionRef);

  if (!sectionId) return;

  const { mainEl, thumbsEl } = getMobileSwiperNodes(sectionId);
  const mainSwiper = mainEl?.swiper || null;
  const thumbSwiper = thumbsEl?.swiper || null;

  if (
    !mainEl ||
    !thumbsEl ||
    !mainSwiper ||
    !thumbSwiper ||
    mainSwiper.destroyed ||
    thumbSwiper.destroyed
  ) {
    initMobileSwiper(sectionId, options);
    return;
  }

  window.__productMediaSwiperDebug?.snapshot(
    sectionId,
    `before-refresh:${options.source || "unknown"}`,
  );

  mainSwiper.allowTouchMove = true;
  mainEl.style.touchAction = "pan-y";
  thumbsEl.style.touchAction = "pan-y";

  requestAnimationFrame(() => {
    if (!mainSwiper.destroyed) {
      mainSwiper.update();
      mainSwiper.updateSlidesClasses();
    }

    if (!thumbSwiper.destroyed) {
      thumbSwiper.update();
      thumbSwiper.updateSlidesClasses();
    }
  });

  window.setTimeout(() => {
    if (!mainSwiper.destroyed) {
      mainSwiper.allowTouchMove = true;
      mainSwiper.update();
    }

    if (!thumbSwiper.destroyed) {
      thumbSwiper.update();
    }

    window.__productMediaSwiperDebug?.snapshot(
      sectionId,
      `after-refresh:${options.source || "unknown"}`,
    );
  }, 120);
}

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");

        this.wishlistUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.wishlistUpdate,
          this.updateWishlist.bind(this),
        );
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.autoSelectVariantFromLocal();

        // On initial page load, uncheck non-color options (size, waist/length)
        // so users are forced to explicitly select them.
        // Use setTimeout(0) to defer this AFTER all DOMContentLoaded handlers
        // (single-size picker, auto-select variant picker) have finished.
        // This ensures our uncheck is the absolute last thing to run on load.
        const self = this;
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => {
            setTimeout(() => self.uncheckNonColorOnLoad(), 0);
          });
        } else {
          setTimeout(() => self.uncheckNonColorOnLoad(), 0);
        }

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true }),
        );
        
        // ─── 1. Initial sync when modal is opened (keep this) ───────
        const modalObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open' && mutation.target.hasAttribute('open')) {
              const modal = mutation.target;
              syncModalWithMainPDP(modal);
            }
          });
        });

        document.querySelectorAll('modal-dialog[id^="StickyVariantModal-"]').forEach(modal => {
          modalObserver.observe(modal, { attributes: true });
        });

        // ─── 2. Sync function (extracted so we can call it from multiple places) ───────
        function syncModalWithMainPDP(modal) {
          if (!modal || !modal.hasAttribute('open')) return;

          const mainSizePicker   = document.querySelector('product-info:not([id*="Modal"]) .size-picker');
          const mainLengthPicker = document.querySelector('product-info:not([id*="Modal"]) .length-picker');

          const modalSizePicker   = modal.querySelector('.size-picker');
          const modalLengthPicker = modal.querySelector('.length-picker');
          const modalVariantInput = modal.querySelector('.product-variant-id');

          // Size Sync
          if (mainSizePicker && modalSizePicker) {
            const mainChecked = mainSizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)');
            if (mainChecked) {
              const targetValue = mainChecked.value;
              const modalInput = modalSizePicker.querySelector(`input[value="${targetValue}"]`);
              if (modalInput && !modalInput.checked) {
                modalInput.checked = true;
                modalInput.setAttribute('checked', 'checked');
                modalInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else {
              /** 
               * NEW: If NOTHING is selected on main PDP, we must 
               * explicitly UNCHECK everything in the modal.
               */
              modalSizePicker.querySelectorAll('input[type="radio"]:not(.toggle-radio)').forEach(input => {
                input.checked = false;
                input.removeAttribute('checked');
              });
              if (modalVariantInput) modalVariantInput.value = "";
            }
          }

          // Length Sync
          if (mainLengthPicker && modalLengthPicker) {
            const mainChecked = mainLengthPicker.querySelector('input[type="radio"]:checked');
            if (mainChecked) {
              const targetValue = mainChecked.value;
              const modalInput = modalLengthPicker.querySelector(`input[value="${targetValue}"]`);
              if (modalInput && !modalInput.checked) {
                modalInput.checked = true;
                modalInput.setAttribute('checked', 'checked');
                modalInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else {
              /** 
               * NEW: Uncheck if main length picker is empty
               */
              modalLengthPicker.querySelectorAll('input[type="radio"]').forEach(input => {
                input.checked = false;
                input.removeAttribute('checked');
              });
            }
          }

          // ─── Force correct text in selected spans after sync ───────
          const sizeSpan   = modal.querySelector('#selected-size');
          const lengthSpan = modal.querySelector('#selected-length');

          if (sizeSpan && modalSizePicker) {
            const checkedSize = modalSizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)');
            if (checkedSize) {
              let displayValue = checkedSize.value.trim();
              displayValue = displayValue.replace(/[^0-9a-zA-Z\s-]/g, '').trim();
              sizeSpan.textContent = displayValue;
              sizeSpan.style.display = '';   
            } else {
              // NEW: Hide if no selection
              sizeSpan.textContent = '';
              sizeSpan.style.display = 'none';
            }
          }

          if (lengthSpan && modalLengthPicker) {
            const checkedLength = modalLengthPicker.querySelector('input[type="radio"]:checked');
            if (checkedLength) {
              let displayValue = checkedLength.value.trim();
              displayValue = displayValue.replace(/[^0-9a-zA-Z\s-]/g, '').trim();
              lengthSpan.textContent = displayValue;
              lengthSpan.style.display = '';
            } else {
              // NEW: Hide if no selection
              lengthSpan.textContent = '';
              lengthSpan.style.display = 'none';
            }
          }
        }

        // ─── 3. NEW: Listen to main page changes and push to open modal ───────
        document.addEventListener('change', (e) => {
          if (e.target.type !== 'radio') return;

          // Only care about main page changes (ignore modal radios here)
          const isMainPageChange = !e.target.closest('modal-dialog');
          if (!isMainPageChange) return;

          // Find currently open modal
          const openModal = document.querySelector('modal-dialog[id^="StickyVariantModal-"][open]');
          if (openModal) {
            if (openModal) {
            const errorEl = openModal.querySelector('.sticky-error-message');
            if (errorEl) {
              errorEl.textContent = '';
              errorEl.style.display = 'none';
            }
          }
            syncModalWithMainPDP(openModal);
          }
        }, true);
      }

      // Order history page buy again button redirect to the pdp page with values
      autoSelectVariantFromLocal() {
        const storedOptionsStr = localStorage.getItem("buyAgainOptions");
        if (!storedOptionsStr) return;

        const storedOptions = JSON.parse(storedOptionsStr);
        localStorage.removeItem("buyAgainOptions");

        // Now apply the selection using stored values
        let selected = false;

        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get("variant");
        if (variantIdFromUrl) {
          const inputById = this.querySelector(
            `input[value="${variantIdFromUrl}"]`,
          );
          if (inputById && inputById.type === "radio") {
            inputById.checked = true;
            inputById.dispatchEvent(new Event("change", { bubbles: true }));
            selected = true;
          }
        }

        if (!selected) {
          const targetSize = storedOptions.size;
          const targetLength = storedOptions.length;
          const targetColor = storedOptions.color;

          // COLOR
          const colorPicker = this.querySelector(".color-picker");
          if (colorPicker) {
            const colorInput = colorPicker.querySelector(
              `input[type="radio"][value="${targetColor}"]`,
            );
            if (colorInput) {
              colorInput.checked = true;
              colorInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

          // SIZE
          const sizePicker = this.querySelector(".size-picker");
          if (sizePicker) {
            const sizeInput = sizePicker.querySelector(
              `input[type="radio"][value="${targetSize}"]`,
            );
            if (sizeInput) {
              sizeInput.checked = true;
              sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

          // LENGTH
          const lengthPicker = this.querySelector(".length-picker");
          if (lengthPicker) {
            const lengthInput = lengthPicker.querySelector(
              `input[type="radio"][value="${targetLength}"]`,
            );
            if (lengthInput) {
              lengthInput.checked = true;
              lengthInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

          const variantSelects = this.querySelector("variant-selects");
          if (variantSelects) {
            variantSelects.dispatchEvent(
              new Event("change", { bubbles: true }),
            );
          }
        }
      }

      // Uncheck non-color options on initial page load so users must
      // explicitly select size/waist. Color stays auto-selected.
      uncheckNonColorOnLoad() {
        // Skip if Buy Again redirect is active (autoSelectVariantFromLocal handles that)
        if (localStorage.getItem("buyAgainOptions")) return;

        const variantSelects = this.querySelector("variant-selects");
        if (!variantSelects) return;

        // Uncheck ALL radios in non-color fieldsets
        variantSelects
          .querySelectorAll("fieldset.product-form__input")
          .forEach((fieldset) => {
            if (fieldset.classList.contains("color-picker")) return;

            // Skip single-option fieldsets (e.g. only 1 size available)
            // These should stay auto-selected like Abercrombie's is_single_size
            const visibleRadios = Array.from(
              fieldset.querySelectorAll('input[type="radio"]:not(.toggle-radio)')
            ).filter((r) => r.offsetParent !== null);
            if (visibleRadios.length <= 1) return;

            fieldset
              .querySelectorAll('input[type="radio"]:not(.toggle-radio)')
              .forEach((radio) => {
                radio.checked = false;
                radio.removeAttribute("checked");
              });

            // Hide the "selected value" label span inside this fieldset
            const selectedSpan = fieldset.querySelector(
              'legend [id^="selected-"]'
            );
            if (selectedSpan) selectedSpan.style.display = "none";
          });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.wishlistUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel"),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

       attemptAutoSubmit(variantId = null) {
        // Modal detection + validation
        const modal = document.querySelector(
          'modal-dialog[id^="StickyVariantModal-"]:not(.hidden)',
        );
        if (!modal) return; 

        // Scoped validation (requires <product-form> from add-bag-modal.liquid update)
        const modalFormEl = modal.querySelector("product-form");
        if (!modalFormEl || !modalFormEl.isAllVariantsSelected()) {
          return;
        }

        const modalVariantId = modal.querySelector('input[name="id"]')?.value;
       
        // Confirm available variant
        const variantJson = modal.querySelector("[data-selected-variant]");
        if (!variantJson) {
          return;
        }
        const variant = JSON.parse(variantJson.textContent);

        // Use passed variantId if available, otherwise fallback to JSON
        const finalVariantId = variantId || variant?.id;

        if (!variant.available) {
          return;
        }

        const form = modal.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        // Force update the input just in case
        const variantInput = form.querySelector(".product-variant-id");
        if (variantInput && finalVariantId) {
          variantInput.value = finalVariantId;
        }

        // Dispatch submit (simulates button click, but bubbles to handler)
        form.dispatchEvent(
          new SubmitEvent("submit", {
            bubbles: true,
            cancelable: true,
            submitter: form.querySelector('button[type="submit"]'), // Mimic real submit button
          }),
        );
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        if (event.target.name === "sizepanel-measurement") return;

        this.resetProductFormState();

        const editModal = this.closest(".quick-update-btn");
        if (editModal) {
          const oldVariantDiv =
            editModal.querySelector("#old-variant-id") ||
            this.querySelector("#old-variant-id");
          const oldVariantId = oldVariantDiv
            ? oldVariantDiv.textContent.trim()
            : null;

          if (oldVariantId) {
            // --- Read the full variants array from the embedded JSON blob ---
            const variantSelects = this.querySelector("variant-selects");
            const variantsScript = variantSelects?.querySelector(
              "script[data-product-variants]"
            );

            if (variantsScript) {
              try {
                const allVariants = JSON.parse(variantsScript.textContent);

                // Collect the currently selected values for each option
                // (option1, option2, option3 … correspond to position order)
                const selectedOptions = [];
                variantSelects
                  .querySelectorAll("fieldset.product-form__input")
                  .forEach((fieldset) => {
                    const checked = fieldset.querySelector(
                      'input[type="radio"]:checked:not(.toggle-radio)'
                    );
                    if (checked) selectedOptions.push(checked.value);
                  });

                // Find the matching variant
                const matched = allVariants.find((v) => {
                  const opts = [v.option1, v.option2, v.option3].filter(Boolean);
                  return selectedOptions.every((sel, i) => opts[i] === sel);
                });

                if (matched) {
                  // Write the resolved ID directly — Update button is now safe
                  // to fire at any time with no race condition.
                  editModal
                    .querySelectorAll(".update-button-quick-modal")
                    .forEach((btn) => {
                      btn.dataset.variantId = String(matched.id);
                      btn.disabled = false;
                      btn.classList.remove("disabled");
                    });
                  // Signal to update-button.js that no fetch-await is needed
                  window._pendingVariantFetch = null;
                }
              } catch (e) {
                // JSON parse failed — fall back to fetch-based resolution
              }
            }

            // Fallback: still enable button even if JSON match failed
            editModal.querySelectorAll(".update-button-quick-modal").forEach((btn) => {
              btn.disabled = false;
              btn.classList.remove("disabled");
            });
          }
        }
        // ─────────────────────────────────────────────────────────────────────


        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
        const sizeErrorEl = this.querySelector(
          ".product-form__error-message-wrapper-variant",
        );

        if (sizeErrorEl) sizeErrorEl.style.display = "none";

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            if (this.dataset.originalSection) {
              // Fix: Skip replacing the ENTIRE product-info wrapper inside the modal.
              // All necessary sub-components (price, images, variant-pickers, buttons)
              // are already explicitly updated individually above. Swapping the entire
              // module DOM tree after the fact is what causes the 500ms browser freeze.
            } else {
              HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector("product-info"),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks,
              );
            }
          }
          this.attemptAutoSubmit(variant?.id);
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        window._variantFetchCounter = (window._variantFetchCounter || 0) + 1;
        const myFetchId = window._variantFetchCounter;

        const activeModal = this.closest(".quick-update-btn");
        if (activeModal) {
          activeModal
            .querySelectorAll(".update-button-quick-modal")
            .forEach((btn) => {
              btn.disabled = true;
              btn.classList.add("disabled", "loading");
            });
        }

        // ─── INSTANT CACHE: Skip parsing huge DOM trees ──────────
        window._variantHTMLCache = window._variantHTMLCache || new Map();
        if (window._variantHTMLCache.has(requestUrl)) {
          const cachedHTML = window._variantHTMLCache
            .get(requestUrl)
            .cloneNode(true);
          callback(cachedHTML);
          this.querySelector(`#${targetId}`)?.focus();
          window._pendingVariantFetch = null;
          return;
        }

        window._pendingVariantFetch = fetch(requestUrl, {
          signal: this.abortController.signal,
        })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            window._variantHTMLCache.set(requestUrl, html.cloneNode(true));
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            this.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          })
          .finally(() => {
            // Only the LATEST fetch is allowed to clear the global promise.
            // If a newer fetch started after this one, leave the promise intact.
            if (window._variantFetchCounter === myFetchId) {
              window._pendingVariantFetch = null;
            }
          });
        // ─────────────────────────────────────────────────────────────────────
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]",
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        let modalIsOpen = false;

        document.querySelectorAll(".quick-update-btn").forEach((radio) => {
          if (radio.hasAttribute("open")) {
            modalIsOpen = true;
          }
        });

        if (modalIsOpen) {
          // Removed console.log("is open data"); to clear console noise
        } else {
          // FIX: Use this.querySelector to scope to current product-info element
          // instead of document.querySelector which grabs the first one on the page
          const oldvariantSelects = this.querySelector("variant-selects");

          // Safety check - if no variant selects found in this element, skip
          if (!oldvariantSelects) {
            if (variantSelects) {
              HTMLUpdateUtility.viewTransition(
                this.variantSelectors,
                variantSelects,
                this.preProcessHtmlCallbacks,
              );
            }
            return;
          }

          const checkedRadios = [];
          oldvariantSelects
            .querySelectorAll('input[type="radio"]')
            .forEach((radio) => {
              if (radio.checked || radio.hasAttribute("checked")) {
                checkedRadios.push(radio.value);
              }
            });

          variantSelects
            .querySelectorAll('input[type="radio"]')
            .forEach((radio) => {
              if (
                checkedRadios.includes(radio.value) &&
                radio.hasAttribute("checked")
              ) {
                radio.checked = true;
                radio.setAttribute("checked", "checked");
              } else {
                radio.checked = false;
                radio.removeAttribute("checked");
              }
            });

          const sizeRadioInputs = variantSelects.querySelectorAll(
            '.size-picker input[type="radio"]:checked:not(.toggle-radio)',
          );
          const sizeHasChecked = Array.from(sizeRadioInputs).some((input) =>
            input.hasAttribute("checked"),
          );
          if (!sizeHasChecked) {
            variantSelects
              .querySelectorAll("#selected-size")
              .forEach((span) => {
                span.style.display = "none";
              });
          }

          const lengthRadioInputs = variantSelects.querySelectorAll(
            '.length-picker input[type="radio"]',
          );
          const lengthHasChecked = Array.from(lengthRadioInputs).some((input) =>
            input.hasAttribute("checked"),
          );
          if (!lengthHasChecked) {
            variantSelects
              .querySelectorAll("#selected-length")
              .forEach((span) => {
                span.style.display = "none";
              });
          }
        }
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateVariantInputsUpdate(variant?.id, variant);
          this.attemptAutoSubmit(variant?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = () => false,
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            if (id === "product-update-price") {
              const destinations = this.querySelectorAll(
                ".product-upate-price-flex",
              );
              if (source && destinations.length) {
                destinations.forEach((dest) => {
                  dest.innerHTML = source.innerHTML;
                });
                const sampleBtn = destinations[0].querySelector(
                  ".update-button-quick-modal",
                );
                const newVariantId = sampleBtn?.dataset.variantId;
                const oldVariantDiv = this.querySelector("#old-variant-id");
                const oldVariantId = oldVariantDiv
                  ? oldVariantDiv.textContent.trim()
                  : null;
                // Enable if variant changed (ignore if new variant exists in cart)
                const shouldEnable =
                  newVariantId && oldVariantId && newVariantId !== oldVariantId;
                this.querySelectorAll(".update-button-quick-modal").forEach(
                  (btn) => {
                    if (shouldEnable) {
                      btn.disabled = false;
                      btn.classList.remove("disabled");
                    } else {
                      btn.disabled = true;
                      btn.classList.add("disabled");
                    }
                  },
                );
              }
              return;
            }
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`,
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("product-update-price");

          if (!variant) {
            this.setUnavailable();
            // Still update media gallery even without a full variant selected
            // This ensures gallery images change when only color is changed
            this.updateMedia(html, null, null);
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id, variant?.id);
          this.updateWishlist();

          updateSourceFromDestination("price");
          updateSourceFromDestination("product-price");

          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination("Sku-Accordion-Main", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === "",
          );

          updateSourceFromDestination("QuantityDropdown");

          const qtyWrapper = this.querySelector(
            `#QuantityDropdown-${this.dataset.section}`,
          );
          if (qtyWrapper) {
            const select = qtyWrapper.querySelector(
              `select#Quantity-${this.dataset.section}`,
            );
            if (select) {
              const stock = parseInt(
                select.dataset.stock || select.options.length || 0,
                10,
              );
              select.disabled = stock <= 0;
              select.classList.toggle("qtyDistabledDropdown", stock <= 0);
            }
          }

          this.updateQuantityRules(this.sectionId, html);

          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden"),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove("hidden");

          this.productForms.forEach((form) =>
            form.toggleSubmitButton(
              html
                .querySelector(".product-form__submit")
                ?.hasAttribute("disabled") ?? true,
              window.variantStrings.soldOut,
            ),
          );

          const newAddBagHtml = html.querySelector(
            ".product-form__buy-buttons.add-bag",
          )?.innerHTML;
          if (newAddBagHtml) {
            const sectionToken = `-${this.dataset.section}-`;
            document
              .querySelectorAll(".product-form__buy-buttons.add-bag")
              .forEach((div) => {
                const submitBtn = div.querySelector('[id^="ProductSubmitButton-"]');
                if (!submitBtn || submitBtn.id.includes(sectionToken)) {
                  div.innerHTML = newAddBagHtml;
                }
              });
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(".product-variant-id").forEach((input) => {
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantInputsUpdate(variantId, variant) {
        // Select all product-info components inside the modal
        const input = this.querySelector("#variant-id-input");

        if (input) {
          // if (input.value !== String(variantId)) {
          input.value = variantId ?? "";
          // }
        }

        const wishlistBtn = this.querySelector(".wishlist-btn"); // "Add to List" button
        const addedBtn = this.querySelector(".remove-list"); // "Added to List!" button

        let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];

        // Show correct button on load
        if (
          wishlist.some(
            (item) => item.variantColor == variant?.option1,
            //  ||
            //   item.idvariantColor == variant?.option2
          )
        ) {
          if (wishlistBtn) wishlistBtn?.classList?.add("!hidden");
          if (wishlistBtn) addedBtn?.classList?.remove("!hidden");
        } else {
          if (wishlistBtn) wishlistBtn.classList.remove("!hidden");
          if (addedBtn) addedBtn.classList.add("!hidden");
        }
      }

      // updateURL(url, variantId) {
      //   this.querySelector("share-button")?.updateUrl(
      //     `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
      //   );

      //   if (this.dataset.updateUrl === "false") return;
      //   window.history.replaceState(
      //     {},
      //     "",
      //     `${url}${variantId ? `?variant=${variantId}` : ""}`
      //   );
      // }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`,
        );

        if (this.dataset.updateUrl === "false") return;

        const currentUrl = new URL(window.location.href);
        const hasAppView = currentUrl.searchParams.has("app-view");

        const newUrl = new URL(`${window.location.origin}${url}`);
        if (variantId) newUrl.searchParams.set("variant", variantId);

        // Preserve the app-view=true parameter if it exists
        if (hasAppView) {
          newUrl.searchParams.set(
            "app-view",
            currentUrl.searchParams.get("app-view"),
          );
        }

        // Preserve any other unrelated query params or hash fragments
        currentUrl.searchParams.forEach((value, key) => {
          if (!newUrl.searchParams.has(key) && key !== "variant") {
            newUrl.searchParams.set(key, value);
          }
        });
        newUrl.hash = currentUrl.hash;

        // Update browser history without reloading
        window.history.replaceState({}, "", newUrl.toString());
      }

      setUnavailable() {
        this.productForms.forEach((form) =>
          form.toggleSubmitButton(true, window.variantStrings.soldOut),
        );

        const selectors = [
          "price",
          "Inventory",
          "product-price",
          // Removed "product-update-price" from this list (fixes button visibility; it's now always updated via HTML replacement)
          "Sku",
          "Sku-Accordion-Main",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
          "QuantityDropdown",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        this.querySelectorAll(selectors).forEach(({ classList }) =>
          classList.add("hidden"),
        );
      }

      updateMedia(html, variantFeaturedMediaId, variantId) {
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const originalSection =
          this.dataset.originalSection || this.dataset.section;

        const mobilemediaGallerySource = this.querySelector(
          `#swiper-mobile-media-${this.dataset.section}`,
        );
        const mobilemediaGalleryDestination = html.querySelector(
          `#swiper-mobile-media-${originalSection}`,
        );

        if (mobilemediaGallerySource && mobilemediaGalleryDestination) {
          // Replace with ID adjustment to match duplicated IDs in modal
          let newHtml = mobilemediaGalleryDestination.innerHTML.replaceAll(
            originalSection,
            this.dataset.section,
          );
          mobilemediaGallerySource.innerHTML = newHtml;
          // [CART-EDIT] Skip swiper init on cart page — gallery must stay static (non-slideable).
          const _inCartEditModal = !!this.closest(".quick-update-btn");
          if (!_inCartEditModal) {
            requestAnimationFrame(() => {
              initMobileSwiper(this.dataset.section);
            });
          }
        }

        const container = html.querySelector("#side-guide-modal-opener");
        const oldcontainer = this.querySelector("#side-guide-modal-opener");

        this.querySelectorAll("#side-guide-modal-opener").forEach(
          (nodeOfModal) => {
            if (nodeOfModal && container) {
              nodeOfModal.innerHTML = container.innerHTML;
            }
          },
        );

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]"),
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // Add new items
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // Remove old items
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // Refresh source if changed
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // Reorder items to match new destination
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // --- Active media handling ---
        if (variantFeaturedMediaId && window.innerWidth >= 825) {
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true,
          );
        } else {
          // If no variant media, reset first slide as active
          const firstSlide = this.querySelector("media-gallery ul li");
          if (firstSlide) {
            this.querySelectorAll("media-gallery ul li").forEach((slide) =>
              slide.classList.remove("is-active"),
            );
            firstSlide.classList.add("is-active");
          }
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;

        // ✅ update thumbnail list
        const thumbnailSource = this.querySelector(
          `#ThumbnailList-${this.dataset.section}`,
        );
        const thumbnailDestination = html.querySelector(
          `#ThumbnailList-${originalSection}`,
        );

        if (thumbnailSource && thumbnailDestination) {
          thumbnailSource.innerHTML = thumbnailDestination.innerHTML;
        }

        const modal = document.querySelector(".quick-add-modal[open]");
        if (!modal) return; // no modal is open

        if (modal) {
          const selectorkey = `#ThumbnailList-${this.dataset.section}`.replace(
            "quickadd-",
            "",
          );

          const thumbnailSourcemodal = modal.querySelector(
            `#ThumbnailList-${this.dataset.section}`,
          );

          const thumbnailDestination = html.querySelector(selectorkey);
          if (thumbnailSourcemodal && thumbnailDestination) {
            thumbnailSourcemodal.innerHTML = thumbnailDestination.innerHTML;
          }

          if (thumbnailSourcemodal) {
            // ✅ Add "is-active" to the matching li based on featured media (instead of always first)
            const thumbs = thumbnailSourcemodal.querySelectorAll("li");
            thumbs.forEach((li) => li.classList.remove("is-active"));
            let activeThumb;
            if (variantFeaturedMediaId) {
              activeThumb = thumbnailSourcemodal.querySelector(
                `li[data-media-id="${variantFeaturedMediaId}"]`,
              );
            }
            if (!activeThumb) {
              activeThumb = thumbs[0];
            }
            if (activeThumb) {
              activeThumb.classList.add("is-active");
            }
          }
          const oldVariantDiv = this.querySelector("#old-variant-id");
          const oldVariantId = oldVariantDiv
            ? oldVariantDiv.textContent.trim()
            : null;

          // Consolidating button logic: disable if new variant matches original cart item
          const updateBtn = modal.querySelector(".update-button-quick-modal");
          if (updateBtn && oldVariantId) {
            // Button is only enabled if:
            // 1. A valid variant is selected
            // 2. That variant ID is NOT the same as the one we started with
            const shouldEnable =
              variantId && String(variantId) !== String(oldVariantId);

            updateBtn.disabled = !shouldEnable;
            updateBtn.classList.toggle("disabled", !shouldEnable);
            updateBtn.classList.toggle("opacity-50", !shouldEnable);
            updateBtn.classList.toggle("cursor-not-allowed", !shouldEnable);
          }
        }
      }
      updateWishlist() {
        const labels = document.querySelectorAll(".swatch-input__label");

        labels.forEach((label) => {
          label.addEventListener("click", function () {
            // Get the color name from the visually-hidden span (exclude sold-out span)
            const colorNameSpan = this.querySelector(
              ".visually-hidden:not(.label-unavailable)",
            );
            const colorName = colorNameSpan
              ? colorNameSpan.textContent.trim()
              : "Unknown";

            // Optionally get the variant ID from the associated input
            const inputId = this.getAttribute("for");
            const input = document.getElementById(inputId);
            const variantId = input ? input.dataset.variantId : "Unknown";

            const wishlistBtn = this.querySelector(".wishlist-btn"); // "Add to List" button
            const addedBtn = this.querySelector(".remove-list"); // "Added to List!" button

            if (!wishlistBtn && !addedBtn) return;

            let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];

            // Show correct button on load
            if (wishlist.some((item) => item.variantId == variantId)) {
              if (wishlistBtn) wishlistBtn.classList.add("!hidden");
              if (wishlistBtn) addedBtn.classList.remove("!hidden");
            } else {
              if (wishlistBtn) wishlistBtn.classList.remove("!hidden");
              if (addedBtn) addedBtn.classList.add("!hidden");
            }
          });
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden"),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === ".quantity__label") {
              const updatedAriaLabelledBy =
                updated.getAttribute("aria-labelledby");
              if (updatedAriaLabelledBy) {
                current.setAttribute("aria-labelledby", updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = this.querySelector(`#${labelId}`);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent =
                    updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForms() {
        return this.querySelectorAll(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products",
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list",
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}


document.addEventListener('DOMContentLoaded', () => {

  // Helper: Should we open modal?
  function shouldOpenStickyModal() {
    // Look specifically for the main product info picker
    const mainSection = document.querySelector('product-info:not([id*="modal"])') || document.querySelector('product-info');
    if (!mainSection) return true;

    const sizePicker = mainSection.querySelector('.size-picker');
    const lengthPicker = mainSection.querySelector('.length-picker');

    const sizeSelected = sizePicker ? 
      !!sizePicker.querySelector('input[type="radio"]:checked:not(.toggle-radio)') : true;

    const lengthSelected = lengthPicker ? 
      !!lengthPicker.querySelector('input[type="radio"]:checked') : true;

    return !sizeSelected || !lengthSelected;
  }

  // Sticky button click handler
  const stickyButtons = document.querySelectorAll(
    '.sticky-add, [id*="sticky"] button[name="add"], .sticky-add-modal button'
  );

  stickyButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      const needsModal = shouldOpenStickyModal();

      if (needsModal) {
        // Size or Length missing → Opening selection modal
        e.preventDefault();
        
        // Manual fallback: sometimes modal-opener fails to catch the bubble
        const opener = this.closest('modal-opener');
        if (opener) {
          const modalId = opener.getAttribute('data-modal');
          const modal = document.querySelector(modalId);
          if (modal && typeof modal.show === 'function') {
            modal.show(this);
          } else if (modal) {
            modal.setAttribute('open', '');
            modal.classList.remove('hidden');
          }
        }
      } else {
        // Variants selected → Proceeding to add to cart
        e.stopImmediatePropagation();
      }
    }, { capture: true });
  });
});
